import React from 'react';
import { Tooltip, TooltipProps, styled } from '@mui/material';

// Custom styled tooltip that matches the design system
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#003B5C',
    color: '#ffffff',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(11),
    padding: '8px 12px',
    borderRadius: '4px',
    boxShadow: theme.shadows[1],
    fontFamily: theme.typography.fontFamily,
    '& .content': {
      margin: 0,
      padding: 0,
    },
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#003B5C',
  },
}));

interface CustomTooltipProps {
  title: string;
  placement?: TooltipProps['placement'];
  arrow?: boolean;
  children: React.ReactElement;
  isHtml?: boolean;
  /** Light project-configuration tooltip used on develop. */
  variant?: 'default' | 'config';
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ 
  title, 
  placement = 'right', 
  arrow = true, 
  children,
  isHtml = false,
  variant = 'default',
}) => {
  if (!title) {
    return children;
  }

  const tooltipTitle = isHtml ? <div dangerouslySetInnerHTML={{ __html: title }} /> : title;

  if (variant === 'config') {
    return (
      <Tooltip
        title={tooltipTitle}
        placement={placement}
        arrow={false}
        classes={{ tooltip: 'project-configuration-tooltip' }}
      >
        {children}
      </Tooltip>
    );
  }

  return (
    <StyledTooltip
      title={tooltipTitle}
      placement={placement}
      arrow={arrow}
    >
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltip;